import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const event = new Event('nav-close');
    window.dispatchEvent(event);

    if (search && search.startsWith('?position')) return;

    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  }, [pathname, search]);

  return null;
}
